module.exports = {["template-constructor-control-picture_1x1"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="icon noarrow"data-alt="Actual size" data-alt-pos="left" data-alt-offset="43"></div>\n	<div class="icon1x2 noarrow"data-alt="Half size" data-alt-pos="left" data-alt-offset="9"></div>\n\n	<div class="panel">\n	</div>\n\n';
}
return __p;
},}